import "./user-prompt-settings-block.scss";
import { USER_PROMPT_MAX_LENGTH } from "../../../../../../shared/constants/default-user-prompt";

type Props = {
	value: string;
	error: string | null;
	disabled?: boolean;
	onChange: (next: string) => void;
};

export const UserPromptSettingsBlock = ({
	value,
	error,
	disabled,
	onChange,
}: Props) => {
	const length = value.length;
	const overLimit = length > USER_PROMPT_MAX_LENGTH;

	return (
		<div className='user-prompt-settings'>
			<div className='user-prompt-settings__title'>
				Промпт текстогенерації
			</div>
			<p className='user-prompt-settings__hint'>
				Діє на всі связки акаунта. До {USER_PROMPT_MAX_LENGTH} символів.
				Очистіть поле і збережіть, щоб прибрати промпт.
			</p>
			<textarea
				className={`user-prompt-settings__textarea${overLimit ? " user-prompt-settings__textarea--error" : ""}`}
				value={value}
				disabled={disabled}
				maxLength={USER_PROMPT_MAX_LENGTH}
				aria-label='Промпт текстогенерації'
				onChange={(event) => onChange(event.target.value)}
			/>
			<div
				className={`user-prompt-settings__counter${overLimit ? " user-prompt-settings__counter--error" : ""}`}>
				{length}/{USER_PROMPT_MAX_LENGTH}
			</div>
			{error ? (
				<div className='user-prompt-settings__error'>{error}</div>
			) : null}
		</div>
	);
};
